export var getQuoteDocumentSupportLanguageList = function getQuoteDocumentSupportLanguageList() {
  return [{
    code: 'BG',
    name: 'Bulgarian'
  }, {
    code: 'CS',
    countryCode: 'CZ',
    name: 'Czech'
  }, {
    code: 'DA',
    countryCode: 'DK',
    name: 'Danish'
  }, {
    code: 'NL',
    name: 'Dutch'
  }, {
    code: 'ET',
    name: 'Estonian'
  }, {
    code: 'FI',
    name: 'Finnish'
  }, {
    code: 'FR',
    name: 'French'
  }, {
    code: 'DE',
    name: 'German'
  }, {
    code: 'EL',
    countryCode: 'GR',
    name: 'Greek'
  }, {
    code: 'HU',
    name: 'Hungarian'
  }, {
    code: 'IT',
    name: 'Italian'
  }, {
    code: 'LV',
    name: 'Latvian'
  }, {
    code: 'LT',
    name: 'Lithuanian'
  }, {
    code: 'NO',
    name: 'Norwegian'
  }, {
    code: 'PL',
    name: 'Polish'
  }, {
    code: 'PT',
    name: 'Portuguese'
  }, {
    code: 'RO',
    name: 'Romanian'
  }, {
    code: 'SK',
    name: 'Slovak'
  }, {
    code: 'SL',
    name: 'Slovenian'
  }, {
    code: 'ES',
    name: 'Spanish'
  }, {
    code: 'SV',
    countryCode: 'SE',
    name: 'Swedish'
  }];
};